import { render, staticRenderFns } from "./ArchiveCategories.vue?vue&type=template&id=4d95076a&scoped=true&"
import script from "./ArchiveCategories.vue?vue&type=script&lang=js&"
export * from "./ArchiveCategories.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveCategories.vue?vue&type=style&index=0&id=4d95076a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95076a",
  null
  
)

export default component.exports